export const zIndexs = {
  map: 1,
  pipes: 2,
  interference: 2,
  projectsCoverage: 3,
  couplesCovarage: 3,
  couplePathLine: 4,
  couplePathStroke: 5,
  sops: 7,
  couplesSensors: 7,
  sensors: 8,
  sensors_pressure: 9,
  waterMeter: 10,
  mobileSamples: 11,
  noiseSamples: 11,
  mobileNoiseSamples: 12,
  alerts: 13,
  mobileAlerts: 13,
  raster: 14,
  scale: 90,
};

export const featuresTypes = {
  ALERT: 'alert',
  NOISE_ALERT: 'noise_alert',
  VALVE_ALERT: 'valve_alert',
  BURST_ALERT: 'burst_alert',
  PRESSURE_ALERT: 'prs_alert',
  SENSOR: 'sensor',
  PRESSURE_SENSOR: 'pressureSensor',
  SENSOR_ON_COUPLE: 'coupleSensor',
  SOP: 'sop',
  NOISE: 'noise',
  WATER_METER: 'waterMeter',
  ASSESSMENT: 'assessment',
  IQUARIUS_PUBLISHED_SAMPLES: 'iQuariusSamplesLayer',
  MOBILE_SAMPLES: 'MOBILE_SAMPLES',
  MOBILE_ALERT: 'mobileAlert',
  INTERFERENCE: 'interference',
  COUPLE_PATH: 'couplePath',
  COUPLES_COVERAGE: 'couplesCoverage',
  PROJECTS_COVERAGE: 'projectsCoverage',
  MOBILE_ALERTS: 'mobileAlerts',
  DMAS: 'dmas',
  PIPES: 'pipes',
  INSPECT_ALERTS: 'inspect_alert',
  PIPES_CONDITION_ASSESSMENTS: 'pca',
};
